import { EFundTabs } from "@frameworks/shared-library/components/TopPerformingFunds/constants";
export var fundTabs = [
    { title: "Equity", eventKey: EFundTabs.EQUITY },
    { title: "Hybrid", eventKey: EFundTabs.HYBRID },
    { title: "Tax Saving", eventKey: EFundTabs.TAX },
];
